// extracted by mini-css-extract-plugin
export default {"list":"AssignmentHome_list__XKzIg","link":"AssignmentHome_link__7vr2K"};